import React from 'react';

interface H1HeaderProps {
    headerText: string | undefined;
}

const H1Header: React.FC<H1HeaderProps> = ({ headerText }) => {
    return (
        <div className="py-5">
            <h1 className="text-4xl font-serif font-bold text-gray-900">
                {headerText}
            </h1>
        </div>
    );
}

export default H1Header;